import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { CanActivate, CanActivateChild, Router, UrlTree } from '@angular/router';
import { isPlatformBrowser } from '@angular/common';

@Injectable({ providedIn: 'root' })
export class TokenGuard implements CanActivate, CanActivateChild {
  constructor(
    private router: Router,
    @Inject(PLATFORM_ID) private platformId: object,
  ) {}

  private checkToken(): boolean | UrlTree {
    // En el servidor, siempre permitir (SSR)
    if (!isPlatformBrowser(this.platformId)) {
      return true;
    }

    // En el navegador, verificar token
    const token = localStorage.getItem('token');

    if (token) {
      return true;
    }

    return this.router.parseUrl('/login');
  }

  canActivate(): boolean | UrlTree {
    return this.checkToken();
  }

  canActivateChild(): boolean | UrlTree {
    return this.checkToken();
  }
}
